/**
* Version 0.100
* 
* Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
* Copyright 2016 - 2025.
* 
* !Changelog

* 	17-10-2018
* 	- [BORN] This class is born. Hooray!
* 
* !Usage
* 
*   - 
* 	
* !Wishlist
* 
* 	// none
* 	
*/

var specific_accordeon = {};

(function () {

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************

	this.onready = function () {



		$(document).on('click', '.js-accordeon-item-toggle', function (e) {

			e.preventDefault();
			var $item = $(this).closest('.accordeon-item');
			$item.toggleClass('active');

			/**
			 * Close all other items
			 */
			$('.accordeon-item').not($item).each(function () {
				$(this).removeClass('active');
				$(this).find('.accordeon-content').stop().slideUp(300);

				/**
				 * Icon
				 */
				$(this).find('.icon svg').css({
					'transform': 'rotate(-180deg)'
				});
			});

			/**
			 * Open or close?
			 */
			if ($item.hasClass('active')) {
				$item.find('.accordeon-content').stop().slideDown(300);

				/**
				 * Scroll to item
				 */
				// $('html, body').stop().animate({
				// 	scrollTop: $item.offset().top - 200
				// }, 500);

				/**
				 * Icon
				 */
				$(this).find('.icon svg').css({
					'transform': 'rotate(0deg)'
				});

			} else {
				$item.find('.accordeon-content').stop().slideUp(300);

				/**
				 * Icon
				 */
				$(this).find('.icon svg').css({
					'transform': 'rotate(-180deg)'
				});

			}

		});

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	// none yet

}).apply(specific_accordeon);